import React, { useMemo } from "react";
import clsx from "clsx";

import { IActiveLearningIssue } from "../../../../../../state";
import TreeCard from "../../../../../../atoms/ActiveLearning/TreeCard";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconEdit } from "../../../../../../assets/images/ActiveLearning/icon_edit.svg";

type Issue1MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue1Material = (props: Issue1MaterialProps) => {
  const question = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const pastAnswersL4 = ["理由", "問題", "原因", "理想状況"];

  const pastAnswersL5 = ["理由", "解決案", "詳細"];

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          このWORKには、今までのLessonで入力してきた、「問い」/「課題」/解決のアイデアとそれを考えた過程が表示されている。
          <br />
          入力内容を振り返り、補足したい情報があれば記載して発表の準備をしよう。
        </p>
      </div>
      <div className={styles.tree}>
        <TreeCard
          title={"問い"}
          text={"回答データがありません。"}
          button={<IconEdit className={styles.editButton} />}
        />
        <ul className={styles.branchList}>
          <li className={styles.branch}>
            <div className={styles.labelWrapper}>
              <span className={styles.label}>理由</span>
            </div>
            <ul className={styles.answerList}>
              <li className={clsx(styles.answer, styles.single)}>
                回答データがありません。
              </li>
              <IconEdit className={styles.editButton} />
            </ul>
          </li>
        </ul>
      </div>
      <div className={styles.tree}>
        <TreeCard
          title={"課題"}
          text={"回答データがありません。"}
          button={<IconEdit className={styles.editButton} />}
        />
        <ul className={styles.branchList}>
          {pastAnswersL4.map((lastAnswer, index) => (
            <li key={index} className={styles.branch}>
              <div className={styles.labelWrapper}>
                <span className={styles.label}>{lastAnswer}</span>
              </div>
              <ul className={styles.answerList}>
                <li className={clsx(styles.answer, styles.single)}>
                  回答データがありません。
                </li>
                <IconEdit className={styles.editButton} />
              </ul>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.tree}>
        <TreeCard
          title={"解決のアイデア"}
          text={"回答データがありません。"}
          button={<IconEdit className={styles.editButton} />}
        />
        <ul className={styles.branchList}>
          {pastAnswersL5.map((lastAnswer, index) => (
            <li key={index} className={styles.branch}>
              <div className={styles.labelWrapper}>
                <span className={styles.label}>{lastAnswer}</span>
              </div>
              <ul className={styles.answerList}>
                <li className={clsx(styles.answer, styles.single)}>
                  回答データがありません。
                </li>
                <IconEdit className={styles.editButton} />
              </ul>
            </li>
          ))}
        </ul>
      </div>
      {question && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question.title}</p>
          <p className={styles.read}>
            考えをまとめたり、伝わりやすくするためのメモを入力しよう。
          </p>
          <div className={styles.textAreaWrapper}>
            <TextArea />
          </div>
        </div>
      )}
    </div>
  );
};
export default Issue1Material;
